import React from 'react';
import { Box, Link, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import VideoPlayer from '@components/VideoPlayer';

const BADMINTON_MENTAL_HEALTH_TOPICS = [
  {
    topic: 'Pressure - Time management and Responsibility',
    focus: 'Challenge area',
    resources: [
      {
        title: 'Maintaining Academic Success and Athletic Activities Together "Under the Shadow of Exam Stress"',
        url: 'https://www.ltmjournal.com/e/article/download/132/98',
        type: 'article',
      },
    ],
  },
  {
    topic: 'Pressure to perform in the game',
    focus: 'Challenge area',
    resources: [
      {
        title: 'Stop Putting Pressure on Yourself During Games',
        url: 'https://www.youtube.com/watch?v=IJpIV8d0pb8',
        type: 'video',
      },
      {
        title: 'Stop Letting Pressure Control Your Performance (3 Mental Tips)',
        url: 'https://www.youtube.com/watch?v=x2oeNLWtunc',
        type: 'video',
      },
    ],
  },
  { topic: 'Stigma', focus: 'Challenge area' },
  { topic: 'Long-term participation', focus: 'Athlete wellbeing' },
  { topic: 'Physical inactivity challenges', focus: 'Challenge area' },
  { topic: 'Labelling', focus: 'Challenge area' },
  { topic: 'Fear and anger', focus: 'Emotional regulation' },
  { topic: 'Anxiety', focus: 'Challenge area' },
  { topic: 'Depression', focus: 'Challenge area' },
  { topic: 'Burnout', focus: 'Challenge area' },
  { topic: 'Eating disorder', focus: 'Health risk' },
  { topic: 'Stress', focus: 'Challenge area' },
  { topic: 'Invisible injuries', focus: 'Recovery and support' },
  { topic: 'Meditate', focus: 'Support practice' },
  { topic: 'Practice yoga', focus: 'Support practice' },
  { topic: 'Healthy diet', focus: 'Support practice' },
  { topic: 'Reduce screen time', focus: 'Support practice' },
  { topic: 'Substance use', focus: 'Risk awareness' },
  { topic: 'Sleeping disturbance', focus: 'Recovery and support' },
  { topic: 'Retirement/career endings', focus: 'Transition support' },
  { topic: 'Social media abuse', focus: 'Challenge area' },
  { topic: 'Overtraining syndrome', focus: 'Health risk' },
  { topic: 'Financial instability', focus: 'Life stressor' },
  { topic: 'Psychological preparation', focus: 'Performance readiness' },
] as const;

export function BadmintonMentalHealthSection() {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Key mental-health topics for the badminton journey. Videos, blog links, or popup detail windows can be attached to these topics in later updates.
      </Typography>
      <TableContainer sx={{ border: '1px solid #e5d9f2', borderRadius: 1, bgcolor: '#fff' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f7f1ff' }}>
              <TableCell sx={{ fontWeight: 700, minWidth: 260 }}>Topic</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Focus</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Resources / Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BADMINTON_MENTAL_HEALTH_TOPICS.map((row) => (
              <TableRow key={row.topic}>
                <TableCell sx={{ fontWeight: 600 }}>{row.topic}</TableCell>
                <TableCell>{row.focus}</TableCell>
                <TableCell>
                  {row.resources?.length ? (
                    <Stack spacing={0.5} alignItems="flex-start">
                      {row.resources.map((resource) => (
                        resource.type === 'video' ? (
                          <Box key={resource.url} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <VideoPlayer url={resource.url} />
                            <Typography variant="body2">{resource.title}</Typography>
                          </Box>
                        ) : (
                          <Link
                            key={resource.url}
                            href={resource.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                          >
                            {resource.title}
                          </Link>
                        )
                      ))}
                    </Stack>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
